/* eslint-disable no-console */
/**
 * --------------------------------------------
 * KANYOS BacktoTop.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'BacktoTop'
const DATA_KEY = 'lte.backtotop'
const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const EVENT_SCROLLTOTOP = `scrolltoTop${EVENT_KEY}`

const SELECTOR_DATA_TOGGLE = '[data-widget="back-to-top"]'
const SELECTOR_HTML_BODY = 'html, body'

const Default = {
  visibleOnScrollTop: 400,
  animationDuration: 800
}

/**
 * Class Definition
 * ====================================================
 */

class BacktoTop {
  constructor(element, _config) {
    this._element = element
    this._config = $.extend({}, Default, _config)

    this._init()
  }

  // Public

  scrolltoTop() {
    const $htmlBody = $(SELECTOR_HTML_BODY)
    $htmlBody.animate({ scrollTop: '0px' }, this._config.animationDuration)

    $(this._element).trigger($.Event(EVENT_SCROLLTOTOP))
  }

  // Private

  _init() {
    this._setVisible()

    $(window).on('scroll', () => {
      this._setVisible()
    })
  }

  _setVisible() {
    const $window = $(window)
    const $backtoTopButton = $(SELECTOR_DATA_TOGGLE)
    const scrollTop = Number.parseInt($window.scrollTop(), 10)
    if (scrollTop >= this._config.visibleOnScrollTop) {
      if (!$backtoTopButton.is(':visible')) {
        try {
          $backtoTopButton.slideDown()
        } catch (error) {
          console.error(error)
          $backtoTopButton.show()
        }
      }
    } else if ($backtoTopButton.is(':visible')) {
      try {
        $backtoTopButton.slideUp()
      } catch (error) {
        console.error(error)
        $backtoTopButton.hide()
      }
    }
  }

  // Static

  static _jQueryInterface(operation) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)
      const _options = $.extend({}, Default, $(this).data())

      if (!data) {
        data = new BacktoTop(this, _options)
        $(this).data(DATA_KEY, data)
      }

      if (typeof operation === 'string' && /scrolltoTop/.test(operation)) {
        data[operation]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

$(document).on('click', SELECTOR_DATA_TOGGLE, event => {
  event.preventDefault()

  let button = event.currentTarget

  if ($(button).data('widget') !== 'back-to-top') {
    button = $(button).closest(SELECTOR_DATA_TOGGLE)
  }

  BacktoTop._jQueryInterface.call($(button), 'scrolltoTop')
})

$(window).on('load', () => {
  BacktoTop._jQueryInterface.call($(SELECTOR_DATA_TOGGLE))
})

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = BacktoTop._jQueryInterface
$.fn[NAME].Constructor = BacktoTop
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return BacktoTop._jQueryInterface
}

export default BacktoTop
